
export default {
    methods: {
        copyGameInfo(url, storyId){
			return url + storyId
		}
    },
}
